/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/no-floating-promises */
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
import { Flex } from '@chakra-ui/react'
import { DescricaoCargo } from '../../../../../interfaces'

interface Props {
  cargos: DescricaoCargo[]
}

export const GraficoDistribuicaoSalarios: React.FC<Props> = ({ cargos }) => {
  useEffect(() => {
    const categorias = {
      abaixo: 0,
      esperado: 0,
      acima: 0
    }

    cargos.forEach(cargo => {
      Object.entries(cargo.niveis).forEach(([nivelNome, nivel]) => {
        const colabs = cargo.colaboradores?.filter(c => c.nivel === nivelNome && c.salario) || []

        colabs.forEach(colab => {
          const salario = colab.salario ?? 0
          if (salario <= nivel.primeiroQuartil) categorias.abaixo++
          else if (salario >= nivel.terceiroQuartil) categorias.acima++
          else categorias.esperado++
        })
      })
    })

    const options = {
      chart: {
        type: 'pie',
        width: '100%',
        height: 280
      },
      labels: ['Abaixo do 1º Quartil', 'Dentro do Esperado', 'Acima do 3º Quartil'],
      colors: ['var(--Red)', 'var(--Azul)', 'var(--Green2)'],
      series: [categorias.abaixo, categorias.esperado, categorias.acima],
      legend: {
        position: 'bottom'
      }
    }

    const chart = new ApexCharts(document.querySelector('#grafico-distribuicao-salarial'), options)
    chart.render()
  }, [cargos])

  return <Flex id="grafico-distribuicao-salarial" w="100%" />
}
